const { tns } = require('../../../node_modules/tiny-slider/src/tiny-slider');

function setActive(info) {
    document.querySelectorAll('.tns-item').forEach((item) => {
        item.classList.remove('paper-card--active');
    });

    document.querySelector(`.tns-item:nth-child(${info.index + 1})`).classList.add('paper-card--active');
}

if (document.querySelector('.js-home-news-cards')) {
    const slider = tns({
        container: '.js-home-news-cards',
        slideBy: 1,
        speed: 500,
        autoplay: false,
        center: false,
        mouseDrag: true,
        nav: false,
        autoplayButtonOutput: false,
        animateIn: 'fadeInDown',
        animateOut: 'fadeOutDown',

        // tiny screens
        items: 1,
        edgePadding: 0,

        responsive: {
            [window.cssBreakpoints.mob]: {
                edgePadding: 70,
                items: 1,
            },
            [window.cssBreakpoints.phab]: {
                edgePadding: 100,
                items: 1,
            },
            [window.cssBreakpoints.tab]: {
                edgePadding: 200,
                items: 1,
            },
            [window.cssBreakpoints.desk]: {
                edgePadding: 0,
                items: 4,
            },
        },

    });
    setActive(slider.getInfo()); // init
    slider.events.on('indexChanged', setActive); // watch
}
